import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/cn";
import { INTERACTIVE } from "@/lib/interaction";

const iconButton = cva(
  `inline-flex shrink-0 items-center justify-center disabled:pointer-events-none disabled:opacity-45 ${INTERACTIVE}`,
  {
    variants: {
      variant: {
        /** 옅은 면에 얹힌 사각 버튼 — 목록 헤더의 ＋ */
        filled: "bg-paper text-ink hover:bg-chip rounded-[10px]",
        /** 배경 없는 아이콘 — 채팅 헤더의 첨부·더보기 */
        plain: "text-muted hover:bg-paper/70 rounded-[10px]",
        /** 다크 레일 위 */
        onDark: "text-paper/70 hover:bg-paper/12 hover:text-paper rounded-[9px]",
      },
      size: {
        sm: "size-8 [&_svg]:size-4",
        md: "size-8.5 [&_svg]:size-[18px]",
        lg: "size-11 [&_svg]:size-5",
      },
    },
    defaultVariants: { variant: "plain", size: "md" },
  },
);

type IconButtonProps = VariantProps<typeof iconButton> & {
  /** 아이콘만 보이므로 접근성 이름은 반드시 받는다. */
  label: string;
} & ComponentPropsWithoutRef<"button">;

export function IconButton({
  variant,
  size,
  label,
  className,
  type = "button",
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn(iconButton({ variant, size }), className)}
      {...rest}
    />
  );
}
